import { createFileRoute } from '@tanstack/react-router';
import { Heading } from '@osd/ui/heading';
import { Text } from '@osd/ui/text';

export const Route = createFileRoute('/about')({
  component: AboutPage,
});

function AboutPage() {
  return (
    <>
      <Heading level={1}>About</Heading>
      <Text>
        This app is the <code>apps/web</code> package inside the OSD Turborepo monorepo. Routes are
        generated by <code>@tanstack/router-plugin</code> from files under <code>src/routes/</code>.
        UI primitives come from <code>@osd/ui</code>.
      </Text>
    </>
  );
}
